import { Box, Chip, Stack, Typography } from "@mui/material";
import AppTable from "components/Shared/AppTable";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useTablePagination } from "hooks";
import React from "react";
import { localizeDateFull } from "utils/dateFormats";
import { useLazyGetVendorProfileQuotationsByProfileQuery } from "store/services/vendorQuotationApi";

const VendorProfileQuotationHistoryScreen = ({ vendorProfileId }) => {
    const { currentPage, perPage, handlePageChange, handlePerRowsChange } =
        useTablePagination();

    const [fetchList, { data: listRes, isLoading, isFetching }] =
        useLazyGetVendorProfileQuotationsByProfileQuery();

    React.useEffect(() => {
        if (!vendorProfileId) return;
        fetchList({ vendorProfileId, page: currentPage, limit: perPage });
    }, [vendorProfileId, currentPage, perPage, fetchList]);

    const columns = [
        {
            name: "Added By",
            selector: (row) => row?.addedBy?.name,
            cell: (row) => <div>{row?.addedBy?.name ?? "N/A"}</div>,
            minWidth: "150px",
        },
        {
            name: "PDF Quotation",
            selector: (row) => row?.vendorQuotationPdf?.title,
            cell: (row) =>
                row?.vendorQuotationPdf ? (
                    <Stack spacing={0.5}>
                        <Chip
                            label={row.vendorQuotationPdf.title ?? row.vendorQuotationPdf.vendorQuotationId}
                            size="small"
                            color="error"
                            variant="outlined"
                        />
                        <Typography variant="caption" color="text.secondary">
                            {row.vendorQuotationPdf.vendorQuotationId}
                        </Typography>
                    </Stack>
                ) : (
                    <Typography variant="caption" color="text.disabled">—</Typography>
                ),
            minWidth: "180px",
        },
        {
            name: "Excel Quotation",
            selector: (row) => row?.vendorQuotationExcel?.title,
            cell: (row) =>
                row?.vendorQuotationExcel ? (
                    <Stack spacing={0.5}>
                        <Chip
                            label={row.vendorQuotationExcel.title ?? row.vendorQuotationExcel.VendorQuotationExcelId}
                            size="small"
                            color="success"
                            variant="outlined"
                        />
                        <Typography variant="caption" color="text.secondary">
                            {row.vendorQuotationExcel.VendorQuotationExcelId}
                        </Typography>
                    </Stack>
                ) : (
                    <Typography variant="caption" color="text.disabled">—</Typography>
                ),
            minWidth: "180px",
        },
        {
            name: "Created At",
            selector: (row) => row?.createdAt,
            cell: (row) => (
                <div>{row?.createdAt ? localizeDateFull(row.createdAt) : "N/A"}</div>
            ),
            minWidth: "160px",
        },
    ];

    return (

        <BreadcrumbLayout.Paper>
            <AppTable
                columns={columns}
                data={listRes?.data}
                paginationServer
                paginationPerPage={perPage}
                paginationDefaultPage={currentPage}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerRowsChange}
                progressPending={isLoading || isFetching}
                paginationTotalRows={listRes?.totalSize ?? 0}
            />
        </BreadcrumbLayout.Paper>
    );
};

export default VendorProfileQuotationHistoryScreen;